import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { CategoriaDespesaService } from '../services/categoria-despesa.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-categorias-desepesa-edit',
  templateUrl: './categorias-desepesa-edit.component.html',
  styleUrls: ['./categorias-desepesa-edit.component.css'],
  animations: [loadingFade]
})
export class CategoriasDesepesaEditComponent implements OnInit {

	public loading;
	public submitting = false;
	public categoria_despesa_id = null;

	public formCategoriaDespesa: FormGroup;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private categoriaDespesaSvc: CategoriaDespesaService,
				private router: Router) { }

  	ngOnInit() {
    	this.criaForm();
		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.categoria_despesa_id = params.id;
				// pega dados a partir do id
				this.categoriaDespesaSvc.getCategoriaDespesa(params.id).then((data: any) => {
					this.preencheForm({
						categoria_despesa_id: data.categoria_despesa_id,
						categoria_despesa_nome: data.categoria_despesa_nome,
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
  	}

    criaForm() {
		this.formCategoriaDespesa = this.fb.group({
			categoria_despesa_id: null,
			categoria_despesa_nome: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formCategoriaDespesa.setValue(dados);
	}

	enviaCategoriaDespesa() {
		if (this.formCategoriaDespesa.valid) {
			this.submitting = true;

			let toSend = this.formCategoriaDespesa.value;

			if (this.categoria_despesa_id === null) { // criar
				this.categoriaDespesaSvc.criaCategoriaDespesa(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Categoria criada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/categoriadespesa']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.categoriaDespesaSvc.editaCategoriaDespesa(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Categoria alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/categoriadespesa']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formCategoriaDespesa.controls){
				let campo = this.formCategoriaDespesa.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formCategoriaDespesa.get(nome);
		return input.touched && input.invalid;
	}
}
